// src/shared/ui/Modal.jsx
//
// Promoted from codebase/components/Modal.jsx (the only one of the app's
// two modal implementations that was portal-based, escape-to-close, and
// scroll-locking — the technically correct one). RolesPage.jsx's inline
// modal markup and base.css's bare `.modal` rules are the other, older
// pattern this replaces. Self-contained CSS (see Modal.css) means this no
// longer needs a ".cb-page" ancestor wrapper the way the old codebase
// Modal did.

import { useEffect } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import "./Modal.css";

export default function Modal({ open, title, onClose, children, footer, size = "md" }) {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow || "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="shui-modal-backdrop" role="dialog" aria-modal="true">
      <div className="shui-modal-overlay" onClick={onClose} />
      <div
        className={`shui-modal${size !== "md" ? ` shui-modal--${size}` : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="shui-modal-header">
          <div className="shui-modal-title">{title}</div>
          <button className="shui-modal-close" onClick={onClose} aria-label="Close" title="Close" type="button">
            ✕
          </button>
        </div>
        <div className="shui-modal-body">{children}</div>
        {footer ? <div className="shui-modal-footer">{footer}</div> : null}
      </div>
    </div>,
    document.body
  );
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.node,
  onClose: PropTypes.func,
  children: PropTypes.node,
  footer: PropTypes.node,
  size: PropTypes.oneOf(["md", "lg", "xl", "xxl"]),
};
